import { render, staticRenderFns } from "./DefaultValueWarnings.vue?vue&type=template&id=85f3fa9e&scoped=true"
import script from "./DefaultValueWarnings.vue?vue&type=script&lang=ts"
export * from "./DefaultValueWarnings.vue?vue&type=script&lang=ts"
import style0 from "./DefaultValueWarnings.vue?vue&type=style&index=0&id=85f3fa9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f3fa9e",
  null
  
)

export default component.exports